import * as React from 'react';

import { NewbuildingField } from '../../../../../../components/Field/newBuildingFlatSale';
import { trackNavigationToCardJK } from './tracking';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const NewbuildingFieldContainer: React.FC = () => {
  const { newbuilding } = useOfferContext();

  const { id: newbuildingId } = newbuilding || {};

  const handleClick = React.useCallback(() => {
    if (newbuildingId) {
      trackNavigationToCardJK({ id: newbuildingId });
    }
  }, [newbuildingId]);

  if (newbuilding) {
    const { images } = newbuilding;
    const imageUrl = (images && images[0].url) || '';

    return <NewbuildingField imageUrl={imageUrl} name={newbuilding.name} url={newbuilding.url} onClick={handleClick} />;
  }

  return null;
};
